/** 将金额统一格式化为“万”单位，贴合设计图展示。 */
export function formatWanValue(value?: number): string {
  if (typeof value !== 'number' || Number.isNaN(value)) return '--';
  const wanValue = value / 10000;
  if (Number.isInteger(wanValue)) {
    return `${wanValue}万`;
  }
  return `${wanValue.toFixed(1)}万`;
}

/** 普通数值展示：整数不保留小数，非整数最多保留两位。 */
export function formatCommonNumber(value?: number): string {
  if (typeof value !== 'number' || Number.isNaN(value)) return '--';
  if (Number.isInteger(value)) return `${value}`;
  return value
    .toFixed(2)
    .replace(/\.0+$/, '')
    .replace(/(\.\d*[1-9])0+$/, '$1');
}

/** 金额千分位格式化：用于表格 Cost 展示，保持原始金额单位且不追加“万”。 */
export function formatThousandNumber(value?: number): string {
  if (typeof value !== 'number' || Number.isNaN(value)) return '--';
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: Number.isInteger(value) ? 0 : 2,
  }).format(value);
}

/**
 * 根据 EAC/Budget 百分比返回设计要求颜色：
 * >115% 红、>110% 橙、>100% 黄、其他绿。
 */
export function getEacBudgetRatioColor(ratio?: number): string {
  if (typeof ratio !== 'number' || Number.isNaN(ratio)) return '#16a34a';
  if (ratio > 115) return '#ef4444';
  if (ratio > 110) return '#f59e0b';
  if (ratio > 100) return '#eab308';
  return '#16a34a';
}

/** 百分比格式化，最多保留一位小数。 */
export function formatPercent(value?: number): string {
  if (typeof value !== 'number' || Number.isNaN(value)) return '--';
  const percentText = Number.isInteger(value)
    ? `${value}`
    : value.toFixed(1).replace(/\.0$/, '');
  return `${percentText}%`;
}
